import { render, staticRenderFns } from "./SuccessfullyCreateSite.vue?vue&type=template&id=a0449c58&scoped=true&"
import script from "./SuccessfullyCreateSite.vue?vue&type=script&lang=js&"
export * from "./SuccessfullyCreateSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0449c58",
  null
  
)

export default component.exports